import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscription: null,
  loading: false,
  error: null,
  usageError: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    fetchSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.subscription = action.payload;
    },
    fetchSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.subscription = null;
    },
    fetchSubscriptionUsageRequest: (state) => {
      state.usageError = null;
    },
    fetchSubscriptionUsageSuccess: (state, action) => {
      state.usageError = null;
      if (state.subscription) {
        state.subscription.usage = action.payload;
      }
    },
    fetchSubscriptionUsageFailure: (state, action) => {
      state.usageError = action.payload;
    },
  },
});

export const selectSubscription = (state) => state.subscription?.subscription ?? null;
export const selectSubscriptionUsage = (state) => state.subscription?.subscription?.usage ?? null;

export const {
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  fetchSubscriptionUsageRequest,
  fetchSubscriptionUsageSuccess,
  fetchSubscriptionUsageFailure,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
